import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        // redirect: "/maintain",
        name: "firstPage",
        meta: {
            title: '首页'
        },
        component: resolve => require(["@/views/firstPage.vue"], resolve)
    },
    {
        path: "/login",
        // redirect: "/maintain",
        name: "login",
        meta: {
            title: '登录'
        },
        component: resolve => require(["@/views/login.vue"], resolve)
    },
    {
        path: "/home",
        // redirect: "/maintain",
        name: "home",
        meta: {
            title: '我的诗歌'
        },
        component: resolve => require(["@/views/home.vue"], resolve)
    },
    {
        path: "/submisson",
        // redirect: "/maintain",

        name: "报名首页",
        meta: {
            title: '填写诗歌'
        },
        component: resolve => require(["@/views/submission.vue"], resolve)
    },
    {
        path: "/layoutsetting",

        name: "layoutsetting",
        meta: {
            title: '选择版式'
        },
        component: resolve => require(["@/views/layoutsettings.vue"], resolve)
    },
    {
        path: "/preview",
        name: "preview",
        meta: {
            title: '预览'
        },
        component: resolve => require(["@/views/preview.vue"], resolve)
    },
    {
        path: "/myattention",
        name: "myattention",
        meta: {
            title: '我的关注'
        },
        component: resolve => require(["@/views/myAttention.vue"], resolve)
    },
    {
        path: "/mycollection",
        name: "mycollection",
        meta: {
            title: '我的收藏'
        },
        component: resolve => require(["@/views/mycollection.vue"], resolve)
    },
    {
        path: "/myinfo",
        name: "myinfo",
        meta: {
            title: '个人中心'
        },
        component: resolve => require(["@/views/myinfo.vue"], resolve)
    },
    {
        path: "/taleInfo",
        name: "taleInfo",
        meta: {
            title: '诗歌展示',
            keepAlive: true
        },
        component: resolve => require(["@/views/taleInfo.vue"], resolve)
    },
    {
        path: "/myvote",
        name: "myvote",
        meta: {
            title: '我的点赞'
        },
        component: resolve => require(["@/views/myVote.vue"], resolve)
    }, {
        path: "/myTaleInfo",
        name: "myTaleInfo",
        meta: {
            title: '诗集详情'
        },
        component: resolve => require(["@/views/mycollectionlist.vue"], resolve)
    }, {
        path: "/ranking",
        name: "ranking",
        meta: {
            title: '排行榜'
        },
        component: resolve => require(["@/views/ranking.vue"], resolve)
    }, {
        path: "/list",
        name: "list",
        meta: {
            title: '榜单'
        },
        component: resolve => require(["@/views/banglist.vue"], resolve)
    }, {
        path: "/totaltale",
        name: "totaltale",
        meta: {
            title: '诗集详情'
        },
        component: resolve => require(["@/views/banglist.vue"], resolve)
    }, {
        path: "/rankingInfo",
        name: "rankingInfo",
        meta: {
            title: '诗集详情'
        },
        component: resolve => require(["@/views/rankingInfo.vue"], resolve)
    }, {
        path: "/othertale",
        name: "othertale",
        meta: {
            title: 'TA的诗集'
        },
        component: resolve => require(["@/views/totaltaleinfo.vue"], resolve)
    }
];

const router = new VueRouter({
    routes
});

router.beforeEach((to, form, next) => {
    document.title = to.meta.title
    let openid = store.state.openid;
    if (!openid && to.path != "/login") {
        router.push({
            path: "/login",
            query: {
                redirect: '/#'+to.fullPath,
            }
        })
    } else if (openid && to.path == "/login") {
        router.push("/");
        next(false);
    } else {

        next();
    }

    // next()
});

export default router;
